import { render, staticRenderFns } from "./RiskIndexInvestigationDetail.vue?vue&type=template&id=4a7914cc&scoped=true"
import script from "./RiskIndexInvestigationDetail.vue?vue&type=script&lang=js"
export * from "./RiskIndexInvestigationDetail.vue?vue&type=script&lang=js"
import style0 from "./RiskIndexInvestigationDetail.vue?vue&type=style&index=0&id=4a7914cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7914cc",
  null
  
)

export default component.exports